/** Storefront strings (English). Keys must match ar.ts. */
export const storeEn = {
  brand: 'Online store',
  links: { empty: 'No links yet.' },
  nav: {
    catalog: 'Products',
    cart: 'Cart',
    cartCount: 'Cart ({{count}})',
    branch: 'Branch',
    signIn: 'Sign in',
    account: 'My account',
    accountShort: 'Account',
    home: 'Home',
    menu: 'Menu',
    categories: 'Categories',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    menuLabel: 'Store menu',
    quick: 'Quick navigation',
    submenu: 'Open the {{name}} menu',
    allCategories: 'All categories',
    searchStore: 'Search the store',
    searchPlaceholder: 'What are you looking for?',
  },
  design: {
    addToCart: 'Add to cart',
    chooseOptions: 'Choose options',
    added: 'Added',
    soldOut: 'Sold out',
    saleSave: 'Save {{amount}}',
    saleWord: 'Sale',
    saleEnds: 'Offer ends {{when}}',
    saleYouSave: 'You save {{amount}} ({{percent}}%)',
    showMore: 'Show more ({{count}})',
    openSection: 'Open',
    previewBadge: 'Preview: what shoppers will see once you publish',
    slider: 'Highlights',
    goToSlide: 'Slide {{n}}',
    open: 'Open',
    seeAll: 'See all',
    tab_featured: 'Recommended',
    tab_all: 'All',
    tab_bestSellers: 'Best sellers',
    tab_newest: 'Newest',
    loadMore: 'Load more…',
    newBadge: 'New',
    dateBadge_roast: 'Roasted {{date}}',
    dateBadge_production: 'Made {{date}}',
    roastDate: 'Roast date: {{date}}',
    wishlistAdd: 'Add to favourites',
    wishlistRemove: 'Remove from favourites',
    noBestSellers: 'Best sellers: this section shows after the first sales (last 30 days).',
    productCount: 'Products: {{count}}',
    shopNow: 'Shop now',
    subcategories: 'Subcategories',
    noCategories: 'No categories yet.',
    noMatch: 'Nothing matches your search.',
    video: 'Video',
    other: 'More',
    menuCategories: 'Menu sections',
    addOne: 'Add one {{name}} to the cart',
    removeOne: 'Remove one {{name}} from the cart',
    inCart: '{{count}} {{name}} in the cart; change the quantity',
    viewCart: 'View cart',
    toMinimum: 'Add {{amount}} to reach the minimum order',
    toFreeDelivery: 'Add {{amount}} for free delivery',
    prevSlide: 'Previous slide',
    nextSlide: 'Next slide',
    notLiveNow: 'Not shown now (schedule)',
    countdownNoEnd: 'Countdown: set the end date and time to show it.',
    countdownEnded: 'This offer has ended; shoppers no longer see it.',
    timeLeft: 'Time left',
    unit_days: 'Days',
    unit_hours: 'Hours',
    unit_minutes: 'Min',
    unit_seconds: 'Sec',
    offer: 'Offer',
    stars: '{{count}} of 5 stars',
    reviews: 'Reviews',
    goToReview: 'Review {{n}}',
    faq: 'Questions and answers',
    gallery: 'Gallery',
    brands: 'Brands',
  },
  info: {
    title: 'Store information',
    openNow: 'Open now',
    closedNow: 'Closed now',
    alwaysOpen: 'Open all day',
    closedDay: 'Closed',
    ready: 'Ready in',
    minutes: '{{count}} min',
    delivery: 'Delivery',
    byArea: 'By area',
    pickup: 'Pickup',
    available: 'Available',
    minimum: 'Minimum order',
    call: 'Call us',
    payOnReceipt: 'Pay on receipt',
  },
  days: {
    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
  },
  social: {
    instagram: 'Instagram',
    tiktok: 'TikTok',
    snapchat: 'Snapchat',
    x: 'X',
    youtube: 'YouTube',
    whatsapp: 'WhatsApp',
  },
  footer: {
    poweredBy: 'Powered by Arabat',
    copyright: '© {{year}} {{name}}',
    backToTop: 'Back to top',
    payments: 'Payment methods',
  },
  account: {
    title: 'My account',
    hello: 'Hello, {{name}}',
    signIn: 'Sign in',
    register: 'Create an account',
    createAccount: 'Create my account',
    signOut: 'Sign out',
    email: 'E-mail',
    password: 'Password',
    passwordHint: 'At least 8 characters.',
    forgot: 'Forgot your password?',
    forgotTitle: 'Reset your password',
    forgotSent: 'If an account exists for this e-mail, a reset link is on its way.',
    sendLink: 'Send the link',
    backToSignIn: 'Back to sign in',
    resetTitle: 'Choose a new password',
    resetDone: 'Your password was changed. Sign in with it.',
    resetButton: 'Change password',
    orders: 'My orders',
    noOrders: 'No orders yet.',
    ordersFailed: 'Your orders could not be loaded.',
    items: '{{count}} items',
    addresses: 'My addresses',
    noAddresses: 'No saved addresses.',
    address: 'Address',
    default: 'default',
    label: 'Label (home, work…)',
    makeDefault: 'Use as my default address',
    addAddress: 'Add an address',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    saved: 'Saved.',
    profile: 'My profile',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    passwordChanged: 'Your password was changed.',
    useSaved: 'Saved address',
    newAddress: 'Another address',
    saveAddress: 'Save this address to my account',
    signInHint: 'Sign in to reuse your details and addresses.',
  },
  home: {
    title: 'Online store',
    description: 'Open the store link your merchant shared with you.',
  },
  closed: 'This store is not taking orders right now. You can still browse.',
  brands: {
    title: 'Brands',
    none: 'No brands yet.',
    label: 'Brand',
    wishlist: 'Favourites',
    wishlistEmpty: 'No favourites yet. Tap the heart on any product.',
  },
  catalog: {
    category: 'Category',
    all: 'All',
    empty: 'No products are available online yet.',
    unavailable: 'Sold out',
    from: 'From {{price}}',
    search: 'Search products',
    featured: 'Featured',
    sort: 'Sort',
    sort_default: 'Default',
    sort_name: 'Name',
    sort_priceAsc: 'Price: low to high',
    sort_priceDesc: 'Price: high to low',
  },
  product: {
    back: 'Back to products',
    variant: 'Option',
    quantity: 'Quantity',
    add: 'Add to cart',
    added: 'Added to cart',
    unavailable: 'Sold out',
    notFound: 'This product is not available.',
    gallery: 'Pictures',
    picture: 'Picture {{n}}',
    share: 'Share',
    linkCopied: 'Link copied',
    breadcrumb: 'You are here',
    home: 'Home',
    products: 'Products',
    sku: 'SKU: {{sku}}',
    inStock: 'In stock',
    fewLeft: 'Only {{count}} left',
    decrease: 'Decrease quantity',
    increase: 'Increase quantity',
    buyNow: 'Buy now',
    askWhatsapp: 'Ask on WhatsApp',
    whatsappText: 'Hello, I have a question about {{name}}: {{url}}',
    description: 'Description',
    details: 'Product details',
    additional: 'Additional information',
    required: 'Required',
    upTo: 'Up to {{count}}',
    choose: 'Choose {{name}}',
    note: 'Leave a note (optional)',
    metaSku: 'SKU:',
    metaCategories: 'Categories:',
    metaBrand: 'Brand:',
    metaSeparator: ',',
    related: 'You may also like',
    recent: 'Recently viewed',
    zoom: 'Enlarge picture',
    closeZoom: 'Close',
    previous: 'Previous picture',
    next: 'Next picture',
    pictureOf: '{{n}} of {{count}}',
  },
  cart: {
    suggested: 'You may also like',
    feesAtCheckout: 'Delivery and offers are worked out at checkout.',
    minimumProgress: 'Minimum order',
    toMinimum: 'Add {{amount}} more to reach the minimum order.',
    continue: 'Continue shopping',
    sample: 'Preview: two sample products stand in for an empty cart.',
    title: 'Your cart',
    empty: 'Your cart is empty.',
    browse: 'Browse products',
    remove: 'Remove',
    subtotal: 'Subtotal',
    checkout: 'Checkout',
    minimum: 'The minimum order is {{amount}}.',
    gone: 'Some items are no longer available and were removed.',
    increase: 'Increase quantity of {{name}}',
    decrease: 'Decrease quantity of {{name}}',
  },
  areaPrompt: {
    title: 'Where should we deliver?',
    pickup: 'Pickup from the branch',
    browse: 'Browse without choosing',
    fee: 'Delivery {{fee}}',
  },
  checkout: {
    previewOnly: 'Preview: nothing can be ordered from here.',
    emailRequired: 'Email',
    terms: 'I agree to the store’s terms',
    readTerms: 'Read the terms',
    termsRequired: 'Agree to the terms to place the order.',
    title: 'Checkout',
    contact: 'Your details',
    name: 'Full name',
    phone: 'Phone',
    email: 'Email (optional)',
    fulfillment: 'How do you want to receive it?',
    pickup: 'Pickup from the store',
    delivery: 'Delivery',
    address: 'Delivery address',
    note: 'Note (optional)',
    payment: 'Payment',
    noMethods: 'No payment option is available right now.',
    payOnReceipt_pickup: 'Pay at pickup',
    payOnReceipt_delivery: 'Pay on delivery',
    payOnReceiptHint:
      'You pay when you receive your order. The store confirms it first; nothing is charged now.',
    branch: 'Pickup branch',
    area: 'Delivery area',
    searchArea: 'Search for your area',
    otherAreas: 'Other areas',
    noAreaMatch: 'No area by that name.',
    minutes: 'about {{count}} min',
    freeFrom: 'Free delivery for orders of {{amount}} or more.',
    when: 'When?',
    asap: 'As soon as possible',
    schedule: 'Choose a time',
    slot: 'Time',
    asapHint: 'Prepared right away',
    scheduleHint: 'Pick a day and time',
    day: 'Day',
    today: 'Today',
    tomorrow: 'Tomorrow',
    slotChosen: 'Your order: {{when}}',
    pickTime: 'Choose the time',
    hour: 'Hour',
    minute: 'Minute',
    confirmTime: 'Confirm time',
    change: 'Change',
    closeSheet: 'Close',
    noSlots: 'No times are available in the next days.',
    chooseFulfillment: 'Choose how you want to receive your order.',
    whenAfterArea: 'Choose your area first to see the times.',
    closedNowLater: 'The store is closed right now. Please try again later.',
    deliveryClosedNow: 'No delivery to your area right now. You can book a later time.',
    deliveryClosedNowLater: 'No delivery to your area right now. Please try again later.',
    notForArea: '{{name}} is not available for your area.',
    removeItem: 'Remove it',
    closedNow: 'The store is closed right now. You can schedule your order for later.',
    promoCode: 'Promotion code',
    apply: 'Apply',
    discount: 'Discount',
    promoApplied: '{{name}} applied.',
    codeIssue_unknown: 'This code does not exist.',
    codeIssue_inactive: 'This code is not active.',
    codeIssue_expired: 'This code has expired.',
    codeIssue_not_started: 'This code is not valid yet.',
    codeIssue_minimum: 'Your order is below the minimum for this code.',
    codeIssue_quantity: 'This code needs more items from the offer in your cart.',
    codeIssue_used_up: 'This code has been used up.',
    codeIssue_customer_limit: 'You have already used this code.',
    codeIssue_no_match: 'This code does not apply to your items.',
    summary: 'Order summary',
    deliveryFee: 'Delivery fee',
    total: 'Total',
    submit: 'Place order and pay',
    submitOnReceipt: 'Place order',
    required: 'Required',
    reserved: 'Items are held for you for a limited time while you pay.',
  },
  pay: {
    title: 'Test payment',
    sandbox: 'Sandbox gateway — no real money is charged.',
    amount: 'Amount',
    order: 'Order',
    merchant: 'Merchant',
    succeed: 'Pay (test success)',
    fail: 'Simulate failure',
    cancel: 'Cancel payment',
    done: 'This payment is {{status}}.',
    back: 'Back to the order',
  },
  order: {
    title: 'Order {{number}}',
    payNow: 'Continue to payment',
    payBy: 'Pay before {{time}} or the order expires.',
    awaitingConfirmation: 'The store will confirm your order shortly.',
    payOnReceipt_pickup: 'You pay when you pick up your order.',
    payOnReceipt_delivery: 'You pay the driver when your order is delivered.',
    timeline: 'Progress',
    items: 'Items',
    refresh: 'Refresh',
    pickup: 'Pickup',
    delivery: 'Delivery',
    notFound: 'This order could not be found.',
    pickupAt: 'Pickup at: {{branch}}',
    wanted: 'Requested time: {{time}}',
    asap: 'As soon as possible',
  },
  status: {
    pending_payment: 'Waiting for payment',
    placed: 'Received',
    confirmed: 'Confirmed',
    paid: 'Paid',
    preparing: 'Being prepared',
    ready: 'Ready for pickup',
    out_for_delivery: 'Out for delivery',
    completed: 'Completed',
    expired: 'Expired (not paid in time)',
    payment_failed: 'Payment failed',
    cancelled: 'Cancelled',
    needs_attention: 'Under review by the store',
  },
  gateway: {
    initiated: 'pending',
    succeeded: 'paid',
    failed: 'failed',
    cancelled: 'cancelled',
    expired: 'expired',
  },
};
